import { Heading, mediaMixin, spaceMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';
import { FooterUpsell } from '@zillow/zhl-wordpress-commons';
import webpBackgroundImageMixin from '../../common/webpBackgroundImageMixin';
import mobileHeroImage from '../../images/ZHL_hero_mobile-3-28.jpg';
import mobileHeroImageWebp from '../../images/ZHL_hero_mobile-3-28.webp';
import tabletHeroImage from '../../images/ZHL_hero-3-28.jpg';
import tabletHeroImageWebp from '../../images/ZHL_hero-3-28.webp';
import desktopHeroImage from '../../images/ZHL_hero-3-20.jpg';
import desktopHeroImageWebp from '../../images/ZHL_hero-3-20.webp';
import ZHLPageHead from '../ZHLHead/ZHLPageHead';
import App from '../App/App';
import HeroImage from '../HeroImage/HeroImage';
import WhyZHL from './WhyZHL';
import LoanTypeComparison from './LoanTypeComparison/LoanTypeComparison.contextual';
import ReviewPreview from './ReviewPreview';
const StyledSubHeading = styled(Heading)`
    padding-top: ${spaceMixin('sm')};
    text-align: center;
`;
const StyledHeading = styled(Heading)``;
const StyledHeroImageContentContainer = styled.div`
    position: absolute;
    top: 18%;
    width: 100%;
    ${mediaMixin(
        'md',
        css`
            top: 20%;
        `
    )};
`;
const StyledHeroImageContent = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    text-align: center;
    ${StyledHeading}, ${StyledSubHeading} {
        color: ${token('colors.white')};
    }
`;
const StyledHeroImage = styled(HeroImage)`
    position: relative;
    background-color: ${token('colors.white')};
    ${webpBackgroundImageMixin(mobileHeroImageWebp.src, mobileHeroImage.src)};
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    height: 350px;
    ${mediaMixin(
        'md',
        css`
            height: 500px;
        `
    )};
    ${mediaMixin(
        'lg',
        css`
            ${webpBackgroundImageMixin(tabletHeroImageWebp.src, tabletHeroImage.src)};
        `
    )}
    ${mediaMixin(
        'xl',
        css`
            background-position-y: top;
            ${webpBackgroundImageMixin(desktopHeroImageWebp.src, desktopHeroImage.src)};
        `
    )}
`;
const StyledLandingContent = styled.div`
    padding-top: ${spaceMixin('xl')};
    padding-bottom: ${spaceMixin('xl')};
    display: flex;
    justify-content: center;
    > * {
        max-width: ${token('sizing.contentWidth')};
    }
`;
const ContentContainer = styled.div`
    ${StyledLandingContent}:nth-child(even) {
        background-color: ${token('colors.backgroundLight')};
    }
`;
const Landing = () => (
    <>
        <ZHLPageHead description="Feel at home with a lender you trust. Let us help you find the right mortgage for you." />
        <App renderLogoutBanner>
            <>
                <StyledHeroImage>
                    <StyledHeroImageContentContainer>
                        <StyledHeroImageContent>
                            <StyledHeading level="1" fontFamily="serif">
                                Feel at home with <br /> a lender you trust
                            </StyledHeading>
                            <StyledSubHeading level="5">
                                Let us help you find the right mortgage for you.
                            </StyledSubHeading>
                            <FooterUpsell gaEventCategory="Home Page" gaEventLabel="Button 2" inverse />
                        </StyledHeroImageContent>
                    </StyledHeroImageContentContainer>
                </StyledHeroImage>
                <ContentContainer>
                    <StyledLandingContent>
                        <WhyZHL />
                    </StyledLandingContent>
                    <StyledLandingContent>
                        <LoanTypeComparison />
                    </StyledLandingContent>
                    <StyledLandingContent>
                        <ReviewPreview />
                    </StyledLandingContent>
                    <StyledLandingContent>
                        <FooterUpsell
                            upsellText="What would you like to do?"
                            gaEventCategory="Home Page"
                            gaEventLabel="Button 5"
                        />
                    </StyledLandingContent>
                </ContentContainer>
            </>
        </App>
    </>
);

export const getStaticProps = async () => ({
    props: {
        imagesToPreload: [[mobileHeroImageWebp.src, null, null, tabletHeroImageWebp.src, desktopHeroImageWebp.src]],
    },
});
export default Landing;
